import { dashboardColors } from '../constants';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line } from 'react-chartjs-2';
import { useEffect, useState } from 'react';
import { useCallback } from 'react';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export const LineChart = ({ allData, date }) => {
  const [dataArr, setDataArr] = useState({
    bioGArr: [],
    pvArr: [],
    windArr: [],
  });
  const { windColor, pvColor, bioGColor } = dashboardColors;

  const getAxisData = useCallback(
    (data) => {
      return data
        .map((reading) => ({
          x: `${reading.date.split('T')[1].split('.')[0].split(':')[0]}:${
            reading.date.split('T')[1].split('.')[0].split(':')[1]
          }`,
          y: reading.value >= 0 ? reading.value.toFixed(0) : 0,
        }))
        .filter(
          (reading) =>
            parseInt(reading.x.replaceAll(':', '')) <=
            parseInt(
              `${date.getHours()}${
                date.getMinutes() < 10 ? '0' : ''
              }${date.getMinutes()}`
            )
        );
    },
    [date]
  );

  useEffect(() => {
    if (allData) {
      setDataArr({
        bioGArr: getAxisData(allData.biomassFacility.production.readings),
        pvArr: allData.solarFacility.production.readings
          .map((reading) => ({
            x: `${reading.date.split('T')[1].split('.')[0].split(':')[0]}:${
              reading.date.split('T')[1].split('.')[0].split(':')[1]
            }`,
            y: reading.value >= 0 ? (reading.value * 1.67).toFixed(0) : 0,
          }))
          .filter(
            (reading) =>
              parseInt(reading.x.replaceAll(':', '')) <=
              parseInt(
                `${date.getHours()}${
                  date.getMinutes() < 10 ? '0' : ''
                }${date.getMinutes()}`
              )
          ),
        windArr: getAxisData(allData.windFacility.production.readings),
      });
    }
  }, [allData, getAxisData, date]);

  // const totalProduction = {
  //   wind: dataArr?.windArr?.reduce((acc, curr) => acc + curr.y, 0),
  //   pv: dataArr?.pvArr?.reduce((acc, curr) => acc + curr.y, 0),
  //   bioG: dataArr?.bioGArr?.reduce((acc, curr) => acc + curr.y, 0),
  // };

  // const percentProduction = {
  //   wind:
  //     (totalProduction.wind /
  //       (totalProduction.wind + totalProduction.pv + totalProduction.bioG)) *
  //     100,
  //   pv:
  //     (totalProduction.pv /
  //       (totalProduction.wind + totalProduction.pv + totalProduction.bioG)) *
  //     100,
  //   bioG:
  //     (totalProduction.bioG /
  //       (totalProduction.wind + totalProduction.pv + totalProduction.bioG)) *
  //     100,
  // };

  // const labels = new Array(96).fill(0).map((_, i) => i);

  const options = {
    hover: {
      intersect: false,
    },
    interaction: {
      mode: 'index',
      axis: 'x',
    },

    scales: {
      x: {
        ticks: {
          callback: function (val, index) {
            return index % 4 === 0 ? this.getLabelForValue(val) : '';
          },
        },
      },
      y: {
        ticks: {
          callback: function (val) {
            return `${val.toFixed(0)} kW`;
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0,
        borderWidth: 2.5,
      },
      point: {
        radius: (ctx) => {
          return ctx.dataIndex === ctx.dataset.data.length - 1 ? 4 : 0;
        },

        hoverRadius: 5,
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        bodyFont: function (context) {
          const width = context.chart.width;
          const size = Math.round(width / 50);
          return {
            size: size,
          };
        },
      },

      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 24);
            return size;
          },
          color: '#333',
          font: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 40);
            return {
              size: size,
            };
          },
        },
      },
      title: {
        display: false,
      },
    },
  };

  const settings = {
    labels: dataArr.windArr.map((reading) => reading.x),
    datasets: [
      {
        datalabels: {
          display: false,
        },
        label: 'Wind',
        data: dataArr.windArr,
        backgroundColor: windColor,
        borderColor: windColor,
      },

      {
        datalabels: {
          display: false,
        },
        label: 'Photovoltaik',
        // label: `Photovoltaik (${Math.round(
        //   percentProduction.pv
        // )}%, ${Math.round(totalProduction.pv)} kWh)`,
        data: dataArr.pvArr,
        backgroundColor: pvColor,
        borderColor: pvColor,
      },
      {
        datalabels: {
          display: false,
        },

        label: 'Biogas',

        data: dataArr.bioGArr,
        backgroundColor: bioGColor,
        borderColor: bioGColor,
      },
    ],
  };
  return (
    <div className='text-center my-4'>
      <h4 className='fs-4 bold-font mb-4'>Erneuerbare Erzeugung für heute</h4>
      <div className='position-relative line-chart-style'>
        <Line options={options} data={settings} plugins={[ChartDataLabels]} />
      </div>
    </div>
  );
};
